import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyCardModule } from '@angular/material/legacy-card';
import { Subject } from 'rxjs';

@Component({
  selector: 'ten-notification-expandable-card',
  templateUrl: './notification-expandable-card.component.html',
  styleUrls: ['./notification-expandable-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatLegacyCardModule, NgIf, MatIconModule],
})
export class NotificationExpandableCardComponent {
  @Input() public type: string;
  @Input() public resultText?: string;
  @Input() public isTaxMessage = false;
  @Input() public isExpanded = false;
  @Output() public expandedChanged = new Subject<boolean>();

  public toggleEllipsis() {
    this.isExpanded = !this.isExpanded;
    this.expandedChanged.next(this.isExpanded);
  }
}
